import React from 'react';
import { Grid, Cell } from 'react-md';

const SpaceDetailsLoader = () => (
  <section className="loading-wrap">
    <div className="my-space-details host-dashboard">
      {/* Header */}
      <div className="header">
        <div className="container custom-container flex-wrap">
          <div className="left">
            <div className="space-arrow-loading loading" />
          </div>
          <div className="right">
            <div className="space-ellipsis-loading loading" />
          </div>
        </div>
      </div>
      {/* Content */}
      <div className="content">
        <div className="container custom-container">
          <div className="header-content">
            <div className="space-ref-title-loading loading" />
            <div className="space-status-badge-loading loading" />
            <div className="space-name-loading loading" />
            <div className="space-location-loading loading" />
          </div>
          <div className="content">
            <div className="space-buttons-section">
              <div className="space-button-loading loading" />
              <div className="space-button-loading loading" />
              <div className="space-button-loading loading" />
            </div>
            <div className="img-wrap">
              <Grid className="space-images-grid">
                {[1, 2, 3, 4].map(i => (
                  <Cell key={i} size={6} phoneSize={12} tabletSize={6} className="space-image-cell">
                    <div className="space-image-loading loading" />
                  </Cell>
                ))}
              </Grid>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default SpaceDetailsLoader;